<template>
  <div id="services">
    <div id="rows" class="d-flex flex-column justify-content-around align-items-center">
      <row class="rowa" v-for="(service, index) in filteredServices[currentLg].slice(0,4)" :key="index" :servicesLg1='service' :servicesLg2='filteredServices.lg2 && filteredServices.lg2[index]'></row>
    </div>
    <div id="additionalServices" class="d-flex flex-column align-items-left">
      <div class="lg1">
        <div>{{ $tlang(this[currentLg], 'ibis.rates.additionalServices') }}</div>
        <div>{{ $tlang(this[currentLg], 'ibis.rates.additionalServicesSubtitle') }}</div>
      </div>
    </div>
    <legalNoticeCenter :legalNoticeLg="legalNoticeLg" :currentLg="currentLg"></legalNoticeCenter>
  </div>
</template>

<script>
  import Row from './rowServices'
  import LegalNoticeCenter from './legalNoticeCenter'

  export default {
    name: 'IbisRatesHorizontalV1Services',
    props: {
      servicesLg: Object,
      currentLg: ''
    },
    components: {
      row: Row,
      'legalNoticeCenter': LegalNoticeCenter
    },
    computed: {
      filteredServices: function () { // remove additional services if necessary
        if (this.servicesLg.lg1.settings.additional_services === '1') {
          return { lg1: this.servicesLg.lg1.otherServices.regular.slice(0, -1), lg2: this.servicesLg.lg2.otherServices.regular.slice(0, -1) }
        } else {
          return { lg1: this.servicesLg.lg1.otherServices.regular, lg2: this.servicesLg.lg2 && this.servicesLg.lg2.otherServices.regular }
        }
      },
      legalNoticeLg () {
        return {lg1: this.servicesLg.lg1.settings.serviceRate_footer.replace(/\r\n/g, '<br>'), lg2: this.servicesLg.lg2 && this.servicesLg.lg2.settings.serviceRate_footer.replace('\r\n', '<br>')}
      },
      lg1 () {
        return this.$store.getters.site.get('rates').get('data').languages[0].name.toLowerCase()
      },
      lg2 () {
        return this.$store.getters.site.get('rates').get('data').languages[1].name.toLowerCase()
      }
    }
  }
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_ibis.scss";

#services {
  margin-top: 103 * 100vh / $srcHeight;
  #rows {
    width: 100%;
    border-bottom: 1px solid $border;

    .rowa:nth-of-type(n+6){
      display:none!important;
    }
  }

  #additionalServices {
    @include heightPercent(149);

    .lg1 {
      margin-top: 3vh;
      div:nth-of-type(1) {
        font-family: "Helvetica-Roman";
        @include fontSize(42);
        max-height: 52 * 100vh / $srcHeight;
        overflow: hidden;
      }

      div:nth-of-type(2) {
        font-family: "Helvetica-Oblique";
        @include fontSize(26);
        max-height: 32 * 100vh / $srcHeight;
        overflow: hidden;
      }
    }

    border-bottom: 1px solid $border;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ibis/rates/horizontal/v1/services/services.vue